import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/elements/Button';
import ForgotPasswordForm from '../../components/forms/ForgotPassword';
import Modal from '../../components/elements/Modal';
import { forgot } from './actions';
import styles from './styles.scoped.css';

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const { isLoading, message } = useSelector((s) => s.forgotPassword);

  useEffect(() => {
    if (message === 'SUKSES') setOpenModal(true);
  }, [message]);

  const onSubmit = (v) => dispatch(forgot(v.email));

  const closeModal = () => {
    setOpenModal(false);
    setTimeout(() => {
      navigate('/login');
    }, 100);
  };

  return (
    <div className={styles.root}>
      <img alt="MerchantApp Logo" src="/assets/logo.svg" />
      <section>
        <h4>Reset Password</h4>
        <p>
          Masukkan alamat e-mail yang Anda gunakan saat mendaftar. Kami akan
          mengirimkan link untuk melakukan reset Password.
        </p>
        <ForgotPasswordForm onSubmit={onSubmit} />
      </section>
      <ModalResponse
        onClose={() => closeModal()}
        open={openModal && !isLoading}
      />
    </div>
  );
}

export function ModalResponse({ open, onClose }) {
  return (
    <Modal className={styles.modal} onClose={onClose} open={open}>
      <img alt="Email Sent" src="/assets/ic-done.svg" />
      <h3>Link reset Password terkirim</h3>
      <p>
        Periksa email Anda dan klik tombol reset Password pada email yang telah
        kami kirim.
      </p>
      <Button onClick={onClose}>Oke</Button>
    </Modal>
  );
}

ModalResponse.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
